
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import debounce from 'lodash/debounce'

@Component({
  name: 'InfiniteScroll'
})
export default class extends Vue {
  @Prop({ default: 1 }) public page!: number
  @Prop({ default: 20 }) public limit!: number
  @Prop({ default: 0 }) public total!: number
  @Prop({ default: false }) public loading!: boolean
  @Prop({ default: 100 }) public distance!: number
  @Prop({ default: true }) public enabled!: boolean

  private debouncedScroll = debounce(this.checkScroll, 200)

  get noMore(): boolean {
    return this.total > 0 && this.page * this.limit >= this.total
  }

  mounted() {
    if (this.enabled) {
      this.bindScroll()
    }
  }

  beforeDestroy() {
    this.unbindScroll()
  }

  @Watch('enabled')
  onEnabledChange(val: boolean) {
    if (val) {
      this.bindScroll()
    } else {
      this.unbindScroll()
    }
  }

  bindScroll() {
    const scrollContainer = this.getScrollContainer()
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', this.handleScroll)
    }
  }

  unbindScroll() {
    const scrollContainer = this.getScrollContainer()
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  }

  getScrollContainer() {
    return this.$refs.infiniteScrollContainer as Element
  }

  handleScroll() {
    if (!this.enabled || this.loading || this.noMore) {
      return
    }
    this.debouncedScroll()
  }

  checkScroll() {
    const container = this.getScrollContainer()
    if (!container) return

    const { scrollTop, scrollHeight, clientHeight } = container

    // 当滚动到底部的距离小于设定的距离时，加载更多数据
    if (scrollHeight - scrollTop - clientHeight <= this.distance) {
      this.loadMore()
    }
  }

  loadMore() {
    if (this.loading || this.noMore) return
    this.$emit('load-more', { page: this.page + 1, limit: this.limit })
  }

  // 暴露给父组件的方法，可以手动触发重新加载
  reset() {
    this.$emit('reset')
  }
}
